import React, { createContext, useReducer, ReactNode, useContext } from 'react';
import { AuthReducer, AuthState, AuthActionType } from './AuthReducer';

type AuthContextType = {
  state: AuthState;
  dispatch: React.Dispatch<AuthActionType>;
};

const getStoredUser = (): AuthState['user'] => {
  const raw = localStorage.getItem('user');
  if (!raw || raw === 'undefined' || raw === 'null') {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch {
    localStorage.removeItem('user');
    return null;
  }
};

const initialState: AuthState = {
  token: localStorage.getItem('token') || '',
  user: getStoredUser(),
};

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(AuthReducer, initialState);

  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
